import { environment } from "src/environments/environment";


export class AppConstants {
  public static server_Url: string = environment["nextGenServerUrl"];
  public static server_query_builder_Url: string = environment["nextGenServerUrl"] + "query-apbuilder/";

  //  signal-R Service url
  public static notification_Url = AppConstants.server_query_builder_Url + "queryapbuildernotificationhub";
  public static checkout_notification = "ReceiveCheckoutNotification";
  public static signalR_connection_api_error = "Error while starting SignalR connection: ";
}